import { useContext } from "react";
import { AppContext } from "../../contexts/app";
import { ACTIONS } from "../../contexts/app/actions";

const useOutline = () => {
  const { state, dispatch } = useContext(AppContext);
  const hovered = state.hovered;

  const addOutline = (object) => {
    document.body.style.cursor = "pointer";
    dispatch({ type: ACTIONS.SET_HOVERED, value: [...object.parent.children] });
  };

  const clearOutline = () => {
    document.body.style.cursor = "auto";

    dispatch({ type: ACTIONS.SET_HOVERED, value: [] });
  };

  return { hovered, addOutline, clearOutline };
};

export default useOutline;
